import React, { useState, useEffect, useContext } from 'react';
import { SetPasswordProps, VerifyUser } from './SetPassword.types';
import { useNavigate, useParams } from 'react-router-dom';
import { AuthContext } from 'contexts/AuthContext';

import { SetPasswordInfo } from 'pages/SetPassword/SetPasswordInfo';
import { SetPasswordInner } from 'pages/SetPassword/SetPasswordInner';
import { Loading } from 'components/Loading';
import { Logo } from 'components/Logo';

import { LoginBottomHalfStyle, LoginStyle, LoginTopHalfStyle, LoginWrapperStyle } from 'styles/pages/login.styles';
import { TotemLoadingStyle } from 'styles/pages/totem.styles';
import { TOKEN } from 'constants/index';
import type { AuthContextType } from 'contexts/AuthContext';
import { useAuthenticateUserMutation } from 'data/__generated__';

export const SetPassword: React.FC<SetPasswordProps> = (props) => {
    const { setSkip } = props;
    const navigate = useNavigate();
    const { stepId } = useParams<{ stepId?: string }>();

    const {
        authActions: { setPassword: storeTokens },
    } = useContext(AuthContext) as AuthContextType;
    const [verifyUser, setVerifyUser] = useState<VerifyUser | null>(null);
    const [authenticateUser] = useAuthenticateUserMutation();
    const token = stepId;

    useEffect(() => {
        const verifyToken = async () => {
            if (!token) return;
            const result = await authenticateUser({ variables: { token } }).catch((e: any) => {
                if (e.message === 'GraphQL error: invalid token') {
                    setVerifyUser({ success: false, error: 'Veuillez vérifier votre lien' });
                } else if (e.message === 'GraphQL error: maxAge exceeded') {
                    setVerifyUser({
                        success: false,
                        error: 'Ce lien a expiré. Veuillez contacter votre office manager',
                    });
                } else {
                    setVerifyUser({
                        success: false,
                        error: 'Il y a eu un problème avec la création de votre compte.',
                    });
                }
            });
            if (result && !verifyUser) {
                const {
                    data: { authenticateUser },
                } = result as { data: { authenticateUser: VerifyUser } };
                setVerifyUser(authenticateUser);
            }
        };
        if (stepId !== '2' && window.TOTEM.storage.get(TOKEN)) {
            navigate('/', { relative: 'path' });
        }
        if (stepId !== '2' && !verifyUser) {
            verifyToken();
        }
    }, [verifyUser, token, stepId, authenticateUser, navigate]);

    if (stepId === '2') {
        return <SetPasswordInfo {...props} />;
    }

    if (!verifyUser) {
        return (
            <TotemLoadingStyle>
                <Loading />
            </TotemLoadingStyle>
        );
    }

    return (
        <LoginStyle>
            <LoginTopHalfStyle>
                <Logo dark />
            </LoginTopHalfStyle>
            <LoginBottomHalfStyle>
                <LoginWrapperStyle>
                    <SetPasswordInner
                        verifyUser={verifyUser}
                        setSkip={setSkip}
                        setPassword={async (response, cb) => {
                            if (response.token && response.refreshToken) {
                                await storeTokens(response.token, response.refreshToken);
                            }
                            cb?.();
                        }}
                        token={token ?? ''}
                    />
                </LoginWrapperStyle>
            </LoginBottomHalfStyle>
        </LoginStyle>
    );
};
